import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ErrorDialogComponent, ErrorDialogData } from './error-dialog/error-dialog.component';

// one for the whole app, so only one error dialog shows at a time
@Injectable({
  providedIn: 'root'
})
export class ErrorDialogService {
  private dialogRef?:MatDialogRef<ErrorDialogComponent>

  constructor(private dialog: MatDialog) {}

  get isShowing() {
    return !!this.dialogRef
  }

  // shows one error at a time; errors while one is showing are counted on it
  openDialog(data:ErrorDialogData): void {
    if (this.dialogRef) {
      this.dialogRef.componentInstance.moreErrors++
      // the count is often raised without the page being redrawn (see the exception service), so the dialog updates itself
      this.dialogRef.componentRef?.changeDetectorRef.detectChanges()
      return
    }

    this.dialogRef = this.dialog.open(ErrorDialogComponent, {
      data,
      maxHeight: '90vh',
      width: '540px',
      maxWidth: '95vw',
      hasBackdrop: true,
      // many failures are followed by moving to another page (a model that can't be loaded, or signing in again);
      // the error stays so the user knows why
      closeOnNavigation: false,
    });

    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = undefined;
    });
  }
}
